import { BaseApi, enhanceOpt } from '../couplingAjax'
import { Services } from '@/store/StoreTypes'

const UserApi = (request: typeof BaseApi, SERVIVE: Services) => {
  return {
    login: {
      out: (opt: enhanceOpt) =>
        request({
          ...opt,
          url: `/${opt.orgid}/logout`,
          method: 'post',
        }),
      pollingAuth: (opt?: enhanceOpt) => {
        return request({
          ...opt,
          url: `/auth/permission`,
          method: 'get',
        })
      },
    },
  }
}

export default UserApi
